





































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import WidgetBox from "@/components/widget-box/widget-box.vue";
import EnergyFlow from "@/components/energyflow.vue";
import Graph from "@/components/graph.vue";
import WeatherService from "@/services/weather-service";
import config from "@/services/api-config";
import GeneralService from "@/services/general-service";
import BarGraph from "@/components/bar-graph.vue";
import WeatherDataGraph from "@/components/weatherDataGraph.vue";
import moment from "moment";

import "../styles/global.scss";

import "../styles/global.scss";

@Component({
  components: {
    "widget-box": WidgetBox,
    "energy-flow": EnergyFlow,
    "weather-data-graph": WeatherDataGraph,
    "bar-graph": BarGraph,
    graph: Graph,
  },
})
export default class Analysis extends Vue {
  private weather = new WeatherService();
  private plantData = JSON.parse(localStorage[config.currentPlant]);
  private userRole = JSON.parse(localStorage[config.userRole]);
  private dashboardData: any = [];
  private yieldData: any = [];
  private isDayData = true;
  private totalGenerated = 0;
  private totalSold = 0;
  private totalPurchased = 0;
  reportEmail = "";
  private totalBattery = 0;
  private range = ["01/09/2018", "01/10/2018"];
  private showCustom = false;
  private customOptions = {
    startDate: moment().startOf("hour"),
    endDate: moment().startOf("hour").add(32, "hour"),
    maxDate: moment().startOf("day").add(1, "day"),
    maxSpan: 60,
  };

  private recentData = [];
  private cloudiness = 0;
  private temperature = 0;
  private graphKey = 0;
  private graphKeyBar = 0;
  private weatherGraphKey = 0;
  private noData = false;
  private today = new Date();
  private todayMidnight = this.today.setHours(0, 0, 0, 0);
  private services = new GeneralService();
  private loading = false;
  private plantWeatherData: any = [];
  reportButton: boolean = false;
  subscribeReport: boolean = false;
  subStartDay = 0;
  subEndDay = 0;
  subDate = 0;
  subscribedEmails=[];

  formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  dateSelected() {}

  dataWeek() {
    this.showCustom = false;
    let newDate = new Date();
    this.isDayData = false;
    this.loading = true;
    newDate.setHours(0, 0, 0, 0);
    let lastWeek = Math.round(newDate.setDate(newDate.getDate() - 7));

    this.services
      .getWeatherData(
        this.plantData,
        lastWeek / 1000,
        Math.round(Date.now() / 1000)
      )
      .then((response) => {
        this.plantWeatherData = response.data.weather_data;
        this.weatherGraphKey++;
      });

    this.services
      .getPlantData(
        this.plantData,
        lastWeek / 1000,
        Math.round(Date.now() / 1000)
      )
      .then((data) => {
        this.dashboardData = data.data.plantdata;
        if (this.dashboardData.length < 1) {
          this.noData = true;
          this.loading = false;
          return;
        }
        this.recentData = this.dashboardData[this.dashboardData.length - 1];
        this.noData = false;
        if (
          !this.recentData ||
          this.recentData == undefined ||
          this.recentData.length < 1
        ) {
          this.noData = true;
        }
        this.graphKey++;
        this.resetData();

        this.totalGenerated = -(
          this.dashboardData[0].lifetimeenergy -
          this.dashboardData[this.dashboardData.length - 1].lifetimeenergy
        );

        if ((this.dashboardData[0] as any).batterystatus == 0) {
          this.totalBattery = 0;
        }

        this.loading = false;
      })
      .catch((e) => {
        this.noData = true;
      });

    this.services
      .getDayWiseData(
        this.plantData,
        lastWeek / 1000,
        Math.round(Date.now() / 1000)
      )
      .then((data) => {
        this.yieldData = data.data.response;
        this.graphKeyBar++;
      });
  }

  showCustomData() {
    this.showCustom = true;
  }

  dataCustom() {
    var start = moment(this.range[0], "DD-MM-YYYY");
    var end = moment(this.range[1], "DD-MM-YYYY");
    this.loading = true;
    this.isDayData = false;
    this.services
      .getWeatherData(
        this.plantData,
        start.toDate() / 1000,
        end.toDate() / 1000
      )
      .then((response) => {
        this.plantWeatherData = response.data.weather_data;
        this.weatherGraphKey++;
      });

    this.services
      .getPlantData(this.plantData, start.toDate() / 1000, end.toDate() / 1000)
      .then((data) => {
        this.dashboardData = data.data.plantdata;
        if (this.dashboardData.length < 1) {
          this.noData = true;
          this.loading = false;
          return;
        }
        this.recentData = this.dashboardData[this.dashboardData.length - 1];
        this.noData = false;
        if (
          !this.recentData ||
          this.recentData == undefined ||
          this.recentData.length < 1
        ) {
          this.noData = true;
        }
        this.graphKey++;
        this.resetData();

        this.totalGenerated = -(
          this.dashboardData[0].lifetimeenergy -
          this.dashboardData[this.dashboardData.length - 1].lifetimeenergy
        );

        if ((this.dashboardData[0] as any).batterystatus == 0) {
          this.totalBattery = 0;
        }
        this.loading = false;
      })
      .catch((e) => {
        this.noData = true;
      });

    this.services
      .getDayWiseData(
        this.plantData,
        start.toDate() / 1000,
        end.toDate() / 1000
      )
      .then((data) => {
        this.yieldData = data.data.response;
        this.graphKeyBar++;
      });
  }

  dataDay() {
    this.showCustom = false;
    this.loading = true;
    this.isDayData = true;
    this.services
      .getWeatherData(
        this.plantData,
        this.todayMidnight / 1000,
        Math.round(Date.now() / 1000)
      )
      .then((response) => {
        this.plantWeatherData = response.data.weather_data;
        this.weatherGraphKey++;
      });

    this.services
      .getPlantData(
        this.plantData,
        this.todayMidnight / 1000,
        Math.round(Date.now() / 1000)
      )
      .then((data) => {
        this.dashboardData = data.data.plantdata;
        if (this.dashboardData.length < 1) {
          this.noData = true;
          this.loading = false;
          return;
        }
        this.recentData = this.dashboardData[this.dashboardData.length - 1];
        this.noData = false;
        if (
          !this.recentData ||
          this.recentData == undefined ||
          this.recentData.length < 1
        ) {
          this.noData = true;
        }
        this.graphKey++;
        this.resetData();

        this.totalGenerated = -(
          this.dashboardData[0].lifetimeenergy -
          this.dashboardData[this.dashboardData.length - 1].lifetimeenergy
        );

        if ((this.dashboardData[0] as any).batterystatus == 0) {
          this.totalBattery = 0;
        }

        this.loading = false;
      })
      .catch((e) => {
        this.noData = true;
      });

    this.services
      .getDayWiseData(
        this.plantData,
        this.todayMidnight / 1000,
        Math.round(Date.now() / 1000)
      )
      .then((data) => {
        this.yieldData = data.data.response;
        this.graphKeyBar++;
      });
  }

  dataMonth() {
    this.showCustom = false;
    let newDate = new Date();
    this.isDayData = false;
    this.loading = true;
    newDate.setHours(0, 0, 0, 0);
    let lastMonth = Math.round(newDate.setDate(newDate.getDate() - 30));

    this.services
      .getWeatherData(
        this.plantData,
        lastMonth / 1000,
        Math.round(Date.now() / 1000)
      )
      .then((response) => {
        this.plantWeatherData = response.data.weather_data;
        this.weatherGraphKey++;
      });
    this.services
      .getPlantData(
        this.plantData,
        lastMonth / 1000,
        Math.round(Date.now() / 1000)
      )
      .then((data) => {
        this.dashboardData = data.data.plantdata;
        if (this.dashboardData.length < 1) {
          this.noData = true;
          this.loading = false;
          return;
        }
        this.recentData = this.dashboardData[this.dashboardData.length - 1];
        this.noData = false;
        if (
          !this.recentData ||
          this.recentData == undefined ||
          this.recentData.length < 1
        ) {
          this.noData = true;
        }
        this.graphKey++;
        this.resetData();

        this.totalGenerated = -(
          this.dashboardData[0].lifetimeenergy -
          this.dashboardData[this.dashboardData.length - 1].lifetimeenergy
        );

        if ((this.dashboardData[0] as any).batterystatus == 0) {
          this.totalBattery = 0;
        }

        this.loading = false;
      })
      .catch((e) => {
        this.noData = true;
      });

    this.services
      .getDayWiseData(
        this.plantData,
        lastMonth / 1000,
        Math.round(Date.now() / 1000)
      )
      .then((data) => {
        this.yieldData = data.data.response;
        this.graphKeyBar++;
      });
  }

  mounted() {
    if (!this.plantData || this.plantData === undefined) {
      this.$router.push("/");
    }
    this.dataDay();

    // this.services.getDayWiseData(this.plantData.serialID)
    // .then(response => {
    //   this.yieldData = response.data.monthwisesavinglst;
    // })
  }

  resetData() {
    this.totalGenerated = 0;
    this.totalSold = 0;
    this.totalPurchased = 0;
    this.totalBattery = 0;
  }

  handleBackPanel() {
    this.$router.push("/dashboard");
  }

  openReportModal() {
    this.reportEmail = "";
    this.subscribeReport = false;
    this.subDate=0;
    this.subStartDay=0;
    this.subEndDay=0;
    if(this.userRole[0]!="admin"){
      this.reportEmail=localStorage[config.currentUsername]
    }
    this.$bvModal.show("sendreportModal");
    this.services.GetMonthlyReport(this.plantData).then((response)=>{
      if(response.data.subscribed_emails.length>0){
        this.subscribedEmails=response.data.subscribed_emails;
      }
    })
  }

  sendReport() {
    this.loading=true;
    var start = moment(this.range[0], "DD-MM-YYYY");
    var end = moment(this.range[1], "DD-MM-YYYY");
    if (this.subscribeReport) {
      if (this.subStartDay == 0) {
        this.$alert("Please Enter a Start day between 1 to 31");
        return;
      } else {
        if (this.subStartDay > 31 || this.subStartDay < 1) {
          this.$alert("Please Enter a Start day between 1 to 31");
          return;
        }
      }
      if (this.subEndDay == 0) {
        this.$alert("Please Enter a End day between 1 to 31");
        return;
      } else {
        if (this.subEndDay > 31 || this.subEndDay < 1) {
          this.$alert("Please Enter a End day between 1 to 31");
          return;
        }
      }
      if (this.subStartDay > this.subEndDay) {
        this.$alert("Start day cannot be greater than End day");
        return;
      }
      if (this.subDate == 0) {
        this.$alert("Please select a report date");
        return;
      } else {
        if(this.subDate>31 || this.subDate<1){
        this.$alert("Please select a report date between 1 and 31");
        return;
        }
      }
    }
    this.services
      .GenerateMonthlyReport(
        this.reportEmail,
        this.plantData,
        start.toDate() / 1000,
        end.toDate() / 1000,
        this.subscribeReport,
        this.subStartDay,
        this.subEndDay,
        this.subDate
      )
      .then((response) => {
        
          this.loading = false;
        if (response.meta.messageTypeId.toLowerCase() == "success") {
          this.$alert(response.meta.text);
          this.$bvModal.hide("sendreportModal");
        } else {
          alert(response.meta.text);
        }
      });
  }

  checkDate(event) {
    var start = moment(this.range[0], "DD-MM-YYYY");
    var end = moment(this.range[1], "DD-MM-YYYY");
    var diff = moment.duration(end.diff(start));
    var diffDays = diff.asDays();
    if (diffDays <= 31) {
      this.reportButton = true;
    } else {
      this.reportButton = false;
    }
  }
}
